import { render, staticRenderFns, recyclableRender, components } from "./index.vue?vue&type=template&id=39d89ade&scoped=true&"
var renderjs
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=39d89ade&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d89ade",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "components/van-one-pic/index.vue"
export default component.exports